<nav role="navigation" class="mobile-navigation">
  <div class="mobile-navigation-container">
    @if (mobileLinkArray().length) {
      <div class="mobile-navigation-menu">
        <button
          #menuLink
          aria-controls="navigationMobileMenu"
          class="menu-icon"
          data-cy="navigationMobileMenuButton"
          [class]="mobileMenuOpen() ? 'icon-exit' : 'icon-search-menu'"
          [attr.aria-expanded]="mobileMenuOpen()"
          (click)="toggleNav()"
        >
          <span>Menu</span>
        </button>
      </div>
    }
    <div class="mobile-navigation-logo" [class.no-menu]="!mobileLinkArray().length">
      <a
        target="_self"
        [dsRouterLink]="homeUrl()"
        [attr.tabIndex]="mobileMenuOpen() ? '-1' : '0'"
        [attr.title]="headerLogo()?.altText ? headerLogo()?.altText : 'logo'"
      >
        <div
          class="logo-container column text-center"
          [style.backgroundImage]="'url(' + headerLogo()?.logoURL + ')'"
          [style.height.px]="headerLogo()?.height"
          [style.width.px]="headerLogo()?.width"
        ></div>
      </a>
    </div>
    @if (loggedIn() && notifications()) {
      <ds-header-mobile-notification
        [notifications]="notifications()"
        [experienceId]="brandInfo()?.brandState?.experienceId"
      ></ds-header-mobile-notification>
    }
  </div>

  <div role="menu" id="navigationMobileMenuItems" data-cy="navigationMobileMenuItems">
    <ul
      data-cy="navigationMobileMenu"
      id="navigationMobileMenu"
      role="navigation"
      [class.open]="mobileMenuOpen()"
      [class.loggedIn]="loggedIn()"
    >
      @for (link of mobileLinkArray(); track $index) {
        <ds-header-mobile-navigation-item
          class="link-item"
          #navItem
          [link]="link"
          [style.display]="mobileMenuOpen() ? 'block' : 'none'"
          (linkClickEvent)="linkClicked($event)"
          (linkBlurEvent)="resetOnBlur($event)"
          (sublinkClickEvent)="sublinkClicked($event)"
          (sublinkTitleClickEvent)="sublinkTitleClicked()"
        >
        </ds-header-mobile-navigation-item>
      }
    </ul>
  </div>
</nav>
